import { FormMain } from "@/features/standard/form/FormMain";
import { FormWrapper } from "@/features/standard/form/FormWrapper";
import { Button, TextInput } from "@mantine/core";
import { InventoriesBetweenGet200ResponseRowsInner } from "@sizlcorp/sizl-api-document/dist/models";
import { useState } from "react";
import { useTranslation } from "react-i18next";

// FormMain 확장
const LotUpdate = Object.assign(FormMain, {
  Wrapper: FormWrapper,
});

type LotUpdateFormProps = {
  data: InventoriesBetweenGet200ResponseRowsInner;
  onSubmit: (updatedName: string) => void;
};

export const LotUpdateForm = ({ data, onSubmit }: LotUpdateFormProps) => {
  const { t } = useTranslation();
  const [lotName, setLotName] = useState(data.lot?.name ?? "");

  const handleSave = () => {
    onSubmit(lotName);
  };

  return (
    <LotUpdate.Wrapper>
      <TextInput label="이전 로트명" value={data.lot?.name ?? ""} readOnly disabled />
      <TextInput
        label={t("로트명")}
        value={lotName}
        onChange={(e) => setLotName(e.currentTarget.value)}
      />
      <Button onClick={handleSave}>{t("저장")}</Button>
    </LotUpdate.Wrapper>
  );
};
